import { Icon } from "../../components/public/ui";
import { useAuthModal } from "../../components/public/auth/AuthModalContext";

const perks = [
  "No credit card required",
  "Instant online browser access",
  "1 free mock exam included",
];

export const FinalCta = () => {
  const { openAuth } = useAuthModal();

  return (
    <section className="w-full py-20 px-6 lg:px-12 bg-surface">
      <div className="max-w-7xl mx-auto relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary via-primary-container to-secondary-container text-on-primary p-10 lg:p-20 shadow-2xl">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-tertiary-fixed/20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-secondary-fixed/20 blur-3xl pointer-events-none" />
        <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center text-center gap-6">
          <span className="px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md text-on-primary font-label-sm text-label-sm uppercase tracking-wider font-semibold">
            Ready to Ace Your Test?
          </span>
          <h2 className="font-display-mobile text-display-mobile sm:font-display sm:text-display text-on-primary">
            Your English Test Success Starts Here.
          </h2>
          <p className="font-body-lg text-body-lg text-on-primary-container max-w-xl">
            Join the candidates using PassEnglishTest to reach their Canadian
            immigration and professional licensing goals.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
            <button
              type="button"
              onClick={() => openAuth("signup")}
              className="inline-flex items-center gap-2 font-label-lg text-label-lg px-8 py-4 rounded-xl bg-surface-container-lowest text-primary shadow-xl hover:bg-surface transition-all hover:scale-105 active:scale-95"
            >
              <span>Get Started Free</span>
              <Icon name="arrow_forward" className="text-lg" />
            </button>
            <a
              className="inline-flex items-center gap-2 font-label-lg text-label-lg px-7 py-4 rounded-xl bg-white/10 hover:bg-white/20 text-on-primary backdrop-blur-md transition-all"
              href="#categories"
            >
              <span>Explore Practice Tests</span>
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 pt-6 text-xs text-on-primary-container">
            {perks.map((perk) => (
              <span key={perk} className="flex items-center gap-1.5">
                <Icon name="check" className="text-base" /> {perk}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
